var l = /* @__PURE__ */ ((d) => (d[d.Success = 0] = "Success", d[d.InvalidUsername = 1] = "InvalidUsername", d[d.InvalidPassword = 2] = "InvalidPassword", d[d.AccountLocked = 3] = "AccountLocked", d[d.GeneralError = 4] = "GeneralError", d[d.AccountAlreadyExists = 5] = "AccountAlreadyExists", d))(l || {});
export {
  l as UserAccountOperationStatus
};
//# sourceMappingURL=index2.js.map
